import Ellipse from "../../../shapes/shapes/Ellipse";
import Rectangle from "../../../shapes/shapes/Rectangle";
import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class MoveLabelsAction extends AbstractProvidedClass {
    movedX = 0;
    movedY = 0;
    initialX;
    initialY;

    constructor(provider, labelCollection) {
        super(provider);

        this.labelCollection = labelCollection;

        this.initialX = this.labelCollection.absX;
        this.initialY = this.labelCollection.absY
    }

    update() {
        let moveX = (this.p.movedX || (this.p.mouseX - this.p.pmouseX)) / this.view.scale;
        let moveY = (this.p.movedY || (this.p.mouseY - this.p.pmouseY)) / this.view.scale;

        if (moveX != 0 || moveY != 0) {
            this.movedX += moveX;
            this.movedY += moveY;
            this.labelCollection.drag(moveX, moveY);
        }
    }

    finish() {
        this.actions.finish();
    }

    undo() {
        this.labelCollection.drag(-this.movedX, -this.movedY);
    }

    redo() {
        this.labelCollection.drag(this.movedX, this.movedY);
    }
}
